import cmp from './AIVerification'

export default cmp
